import React, { useEffect, useState, useCallback } from "react";
import {
    Col,
    Row,
    Card,
    CardBody,
    Button,
    InputGroup,
    Input,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    FormGroup,
} from "reactstrap";
import { Link } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import UserService from "../../services/KangarooServices/UserService";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import CustomDataTable from "../../Components/CustomTable/CustomTable";
import DeleteModal from "../../Components/Common/DeleteModal";
import PortalManagementService from "../../services/KangarooServices/Intelligence/PortalManagementService";
import Select from "react-select";
import ApproveModal from "../../Kangaroo/User/component/ApproveModal";
import ApprovePortalModel from "./component/ApprovePortalModel";




const customStyles = {
    headCells: {
        style: {
            fontSize: "0.92rem",
            fontWeight: 610,
        },
    },
    rows: {
        style: {
            fontSize: "0.9rem",
        },
    },
};

const PortalManagement = () => {
    const [customerList, setCustomerList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isloading, setIsLoading] = useState(false);
    const [notes, setNotes] = useState("");
    const [addModal, setAddModal] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState();
    const navigate = useNavigate();
    const [data, setdata] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isOpenDelete, setIsOpenDelete] = useState(false);
    const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
    const [showApprove, setShowApprove] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [filters, setFilters] = useState({
        SearchText: "",
        portal: "",
        IsAdminApproved: "",
    })

    const portal = [
        {
            value: 1,
            label: "Onshore",
        },
        {
            value: 2,
            label: "Offshore",
        },
        {
            value: 3,
            label: "SmartKampus",
        }
    ]

    const isAdminApproved = [
        {
            value: true,
            label: "Approved",
        },
        {
            value: false,
            label: "UnApproved",
        }
    ]


    const [debouncedFilter, setDebouncedFilter] = useState(filters)
    const toggleModal = (item) => {
        setSelectedCustomer(item);
        setIsModalOpen(!isModalOpen);
    };

    const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

    const toggleApprove = () => setShowApprove(!showApprove);

    const handleApproveClick = (user) => {
        setSelectedUser(user);
        toggleApprove();
    };

    const handleDeleteClick = (item) => {
        setSelectedDeleteItem(item);
        toggleDelete();
    };

    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const pageSize = 10;

    const fetchdata = async (
        page = currentPage,
        size = rowsPerPage,
        currentFilters = debouncedFilter
    ) => {
        setLoading(true);
        try {
            const res = await PortalManagementService.getList({
                page,
                size,
                ...currentFilters,
            });

            setdata(res?.items || []);
            console.log("Fetched user:", res);
        } catch (error) {
            console.error("Error getting user:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setDebouncedFilter(filters);
            // setCurrentPage(1);
        }, 500);
        return () => clearTimeout(timeoutId);
    }, [filters]);

    useEffect(() => {
        fetchdata(currentPage, rowsPerPage, debouncedFilter);
    }, [currentPage, rowsPerPage, debouncedFilter]);


    const columns = [
        {
            name: "S. N",
            cell: (row, index) => (
                <div>{(currentPage - 1) * rowsPerPage + index + 1}</div>
            ),
            width: "75px",
        },
        {
            name: "Name",
            selector: (row) => `${row.userFullName}`,
            cell: (row) => <Link to={`/portal-management/detail/${row?.userId}`}>{row.userFullName}</Link>,
            sortable: true,
        },
        {
            name: "Email",
            selector: (row) => row.userEmail,
            cell: (row) => (
                <span title={row.userEmail} className="cursor-pointer">
                    {row.userEmail}
                </span>
            ),
            sortable: true,
            width: "15vw",
        },
        {
            name: "Portal",
            selector: (row) => row.portal,
            sortable: true,
        },
        {
            name: "Registered Date",
            selector: (row) => row.requestedAt,
            sortable: true,
            cell: (row) => (
                <span>{new Date(row.requestedAt).toLocaleDateString()}</span>
            ),
        },
        // {
        //   name: "Status",
        //   selector: (row) => row.isActive,
        //   sortable: true,
        //   cell: (row) => (
        //     <Badge color={row.isActive ? "success" : "danger"}>
        //       {row.isActive ? "Active" : "Inactive"}
        //     </Badge>
        //   ),
        // },
        {
            name: "Status",
            selector: (row) => row.status,
            sortable: true,
            cell: (row) => {
                let color = "secondary";
                let text = "Unknown";

                if (row.status === "Approved") {
                    color = "success";
                    text = "Approved";
                } else if (row.status === "Pending") {
                    color = "warning";
                    text = "Pending";
                } else if (row.status === "Rejected") {
                    color = "danger";
                    text = "Rejected";
                }

                return <Badge color={color}>{text}</Badge>;
            },
        },
        {
            name: "Action",
            selector: (row) => (
                <div>
                    <Button
                        color="btn btn-soft-warning"
                        className="btn-sm ms-1"
                        onClick={() => toggleModal(row)}

                    >
                        <i className="ri-edit-line" />
                    </Button>
                    <Button
                        className="btn btn-soft-danger btn-sm ms-1"
                        color="danger"
                        onClick={() => handleDeleteClick(row)}

                    >
                        <i className="ri-delete-bin-5-line" />
                    </Button>
                    <Button
                        className={`btn btn-sm ms-1 ${row.status === "Approved" ? "btn-soft-secondary" : "btn-soft-success"
                            }`}
                        color={row.status === "Approved" ? "secondary" : "success"}
                        onClick={() => handleApproveClick(row)}
                        title={row.status === "Approved" ? "Unapprove" : "Approve"}

                    >
                        <i
                            className={
                                row.status === "Approved" ? "ri-close-line" : "ri-check-line"
                            }
                        />
                    </Button>
                </div>
            ),
        },
    ];

    const handleFilterChange = (e) => {
        setFilters((prev) => ({ ...prev, SearchText: e.target.value }));
    };




    const handleDelete = async () => {
        if (selectedDeleteItem) {
            setLoading(true);
            try {
                await UserService.delete(selectedDeleteItem.id);
                await fetchdata();
                toast.success("User deleted successfully");
            } catch (error) {
                toast.error(error?.response?.data?.message || "Failed to delete User");
            } finally {
                setLoading(false);

                toggleDelete();
                setSelectedDeleteItem(null);
            }
        }
    };

    const handleMediaGroupChange = (selectedOption) => {
        setFilters((prev) => ({
            ...prev,
            portal: selectedOption ? selectedOption.value : null,
        }));
    };

    const handleIsAdminApprovedChange = (selectedOption) => {
        setFilters((prev) => ({
            ...prev,
            IsAdminApproved: selectedOption ? selectedOption.value : null,
        }));
    };

    const confirmApprove = async () => {
        if (!selectedUser) return;
        setIsLoading(true);

        try {
            if (selectedUser.status === "Approved") {
                await PortalManagementService.unApproveUser(selectedUser.id, notes);
            } else {
                await PortalManagementService.approveUser(selectedUser.id, notes);
            }

            toast.success(
                `User ${selectedUser.status === "Approved" ? "UnApproved" : "Approved"} successfully!`,
            );

            toggleApprove();
            setNotes("");

            await fetchdata();
        } catch (error) {
            toast.error("Failed to update user.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                <BreadCrumb title="Portal Management" pageTitle="User Management" />
            </div>
            <Row>
                <Col lg={4} className="d-flex  mb-2">
                    <InputGroup >
                        <Input
                            placeholder="Search by anything..."
                            value={filters.SearchText}
                            onChange={handleFilterChange}
                        />
                    </InputGroup>
                </Col>
                <Col xs={7} lg={3} className=" ">
                    <Select
                        options={portal}
                        value={portal.find(
                            (option) => option.value === filters.portal
                        )}
                        onChange={handleMediaGroupChange}
                        placeholder="Select Portal"
                        isClearable
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                    />
                </Col>
                <Col xs={7} lg={3} className=" ">
                    <Select
                        options={isAdminApproved}
                        value={isAdminApproved.find(
                            (option) => option.value === filters.IsAdminApproved
                        )}
                        onChange={handleIsAdminApprovedChange}
                        placeholder="Select Approve Status"
                        isClearable
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                    />
                </Col>

            </Row>


            <CustomDataTable
                responsive
                striped
                pagination
                fixedHeader
                persistTableHead
                progressPending={loading}
                customStyles={customStyles}
                paginationPerPage={rowsPerPage}
                onChangeRowsPerPage={(newPerPage) => setRowsPerPage(newPerPage)}
                onChangePage={(page) => setCurrentPage(page)}
                progressComponent={
                    <div className="my-3">
                        <Triangle
                            visible={true}
                            height="80"
                            width="80"
                            color="#5B71B9"
                            ariaLabel="triangle-loading"
                        />
                        <h5 className="mt-1">Loading...</h5>
                    </div>
                }
                columns={columns}
                data={data}
            />


            <DeleteModal
                show={isOpenDelete}
                onCloseClick={toggleDelete}
                onDeleteClick={handleDelete}
            />
            <ApprovePortalModel
                show={showApprove}
                onApproveClick={confirmApprove}
                onCloseClick={toggleApprove}
                setLoading={setIsLoading}
                loading={isloading}
                selectedUser={selectedUser}
                notes={notes}
                setNotes={setNotes}
            />
        </div>
    );
};

export default PortalManagement;
